module.exports = __webpack_public_path__ + "img/5270d068af91450407440a24c1caa76d.svg";